import { formDefToSimpleColumns } from "../../common/components/DataTable";
import { dynamicSort } from "../../common/utils/tableUtilities";

export const buildColumns = (t, clientConfig) => {
    let columns = [
        { type: 'text', field: 'displayid', title: t('pcrNumber', { count: 1 }) },
        { type: 'text', field: 'firstname', title: t('firstname') },
        { type: 'text', field: 'lastname', title: t('lastname') },
        { type: 'datetime', field: 'creation', title: t('created') },
        { type: 'text', field: 'creator', title: t('creator') },
        { type: 'text', field: 'middlename', title: t('middlename') },
        { type: 'date', field: 'dob', title: t('dob') },
        { type: 'number', field: 'weight', title: t('weight') },
        { type: 'text', field: 'gender', title: t('gender') },
        { type: 'phone', field: 'phone', title: t('phone') },
        { type: 'datetime', field: 'dischargetimestamp', title: t('dischargeTimestamp') },
        { type: 'epcrDisposition', field: 'disposition', title: t('dischargeDestination') },
        { type: 'checkbox', field: 'inforelease', title: t('informationRelease') },
        { type: 'text', field: 'accompaniedby', title: t('accompaniedBy') },
        { type: 'text', field: 'accompanieddetails', title: t('details') },
        { type: 'text', field: 'problem', title: t('chiefComplaint') },
        { type: 'text', field: 'problem2', title: t('secondaryComplaint') },
        { type: 'text', field: 'comments', title: t('comment', { count: 100 }) },
        { type: 'text', field: 'finalassessment', title: t('finalPrimaryImpression') },
        { type: 'text', field: 'finalassessment2', title: t('finalSecondaryImpression') },
        { type: 'datetime', field: 'finalized', title: t('finalized') },
        { type: 'text', field: 'address1', title: t('address1') },
        { type: 'text', field: 'address2', title: t('address2') },
        { type: 'text', field: 'suburb', title: t('suburb') },
        { type: 'text', field: 'state', title: t('state') },
        { type: 'text', field: 'postcode', title: t('postcode') },
        { type: 'text', field: 'aka', title: t('knownas') },
        { type: 'epcrAcuity', field: 'finalpatientacuity', title: t('finalPatientAcuity') },
        { type: 'text', field: 'inforelasename', title: t('informationReleaseName') },
        { type: 'datetime', field: 'inforeleasetime', title: t('informationReleaseTime') },
        { type: 'epcrAcuity', field: 'initialpatientacuity', title: t('initialPatientAcuity') },
    ];

    if (clientConfig.epcrCaseFormSpec) {
        columns = columns.concat(formDefToSimpleColumns(clientConfig.epcrCaseFormSpec, t('caseDetails')).map(cell => ({ ...cell, field: 'customfields.' + cell.field })));
    }
    if (clientConfig.epcrPatientFormSpec) {
        columns = columns.concat(formDefToSimpleColumns(clientConfig.epcrPatientFormSpec, t('details')).map(cell => ({ ...cell, field: 'customfields.' + cell.field })));
    }
    if (clientConfig.ecprHistoryFormSpec) {
        columns = columns.concat(formDefToSimpleColumns(clientConfig.ecprHistoryFormSpec, t('history')).map(cell => ({ ...cell, field: 'customfields.' + cell.field })));
    }
    if (clientConfig.epcrAdditionalTabs) {
        columns = columns.concat(clientConfig.epcrAdditionalTabs.flatMap(tab => formDefToSimpleColumns(tab.formdef, tab.label)).map(cell => ({ ...cell, field: 'customfields.' + cell.field })));
    }
    if (clientConfig.epcrBodyForm) {
        columns = columns.concat(formDefToSimpleColumns(clientConfig.epcrBodyForm, t('injuries')).map(cell => ({ ...cell, field: 'injuries.' + cell.field })));
    }
    if (clientConfig.epcrRefusalFormSpec) {
        columns = columns.concat(formDefToSimpleColumns(clientConfig.epcrRefusalFormSpec, t('refusal')).map(cell => ({ ...cell, field: 'customfields.' + cell.field })))
    }
    if (clientConfig.epcrEventFormSpec) {
        columns = columns.concat(formDefToSimpleColumns(clientConfig.epcrEventFormSpec, t('narrative')).map(cell => ({ ...cell, field: 'eventcustomfields.' + cell.field })));
    }
    if (clientConfig.epcrResultFormSpec) {
        columns = columns.concat(formDefToSimpleColumns(clientConfig.epcrResultFormSpec, t('outcome')).map(cell => ({ ...cell, field: 'eventcustomfields.' + cell.field })));
    }
    if (clientConfig.epcrTreatmentFormSpec) {
        columns = columns.concat(formDefToSimpleColumns(clientConfig.epcrTreatmentFormSpec, t('treatment')).map(cell => ({ ...cell, field: 'customfields.' + cell.field })));
    }

    //eventid
    columns.sort(dynamicSort(['section', 'title']))
    return columns
}